// Code generated by Tortuga protoc-gen-rest-ts. DO NOT EDIT.

/* eslint-disable */
import { ApiError } from "src/core/apiError";
import {
  ReST,
  generateQueryParams,
  generatePayload
} from "src/utils/api/rest/rest";
import { AddTenantRequest } from "src/gen/schema/brig/bapi";
import { UpdateTenantRequest } from "src/gen/schema/brig/bapi";
import { GetTenantsRequest } from "src/gen/schema/brig/bapi";
import { DeleteUsersRequest } from "src/gen/schema/brig/bapi";
import { GetBearerTokensRequest } from "src/gen/schema/brig/btokens";
import { UpdateSupportAccessRequest } from "src/gen/schema/brig/bapi";
import { SubscriptionsResponse } from "src/gen/schema/brig/bapi";
import { ApiKey } from "src/gen/schema/brig/bapikeys";
import { EchoRequest } from "src/gen/schema/common/echo";
import { GetTenantRequest } from "src/gen/schema/brig/bapi";
import { UpdateUser } from "src/gen/schema/brig/bapi";
import { CreateBearerTokenRequest } from "src/gen/schema/brig/btokens";
import { SignEulaRequest } from "src/gen/schema/brig/bapi";
import { Tenant } from "src/gen/schema/models/tenant";
import { DeleteTenantRequest } from "src/gen/schema/brig/bapi";
import { SendOrgInviteEmailRequest } from "src/gen/schema/brig/bapi";
import { GetApiKeysRequest } from "src/gen/schema/brig/bapikeys";
import { AddTenantResponse } from "src/gen/schema/brig/bapi";
import { UpdateTenantsRequest } from "src/gen/schema/brig/bapi";
import { UploadApiKeyRequest } from "src/gen/schema/brig/bapikeys";
import { ApiKeysResponse } from "src/gen/schema/brig/bapikeys";
import { BearerTokensResponse } from "src/gen/schema/brig/btokens";
import { SignDeviceCertRequest } from "src/gen/schema/brig/bapi";
import { DeleteTenantsRequest } from "src/gen/schema/brig/bapi";
import { ClaimSubscriptionsRequest } from "src/gen/schema/brig/bapi";
import { CreateBearerTokensResponse } from "src/gen/schema/brig/btokens";
import { DeleteBearerTokenRequest } from "src/gen/schema/brig/btokens";
import { UserPreferences } from "src/gen/schema/models/user";
import { SupportAccessResponse } from "src/gen/schema/brig/bapi";
import { UpdateOrgRequest } from "src/gen/schema/brig/bapi";
import { TenantsResponse } from "src/gen/schema/brig/bapi";
import { UsersResponse } from "src/gen/schema/brig/bapi";
import { GetUsersRequest } from "src/gen/schema/brig/bapi";
import { UpdateUserRequest } from "src/gen/schema/brig/bapi";
import { BearerToken } from "src/gen/schema/brig/btokens";
import { GetBearerTokenRequest } from "src/gen/schema/brig/btokens";
import { SignEulaResponse } from "src/gen/schema/brig/bapi";
import { EchoResponse } from "src/gen/schema/common/echo";
import { Organization } from "src/gen/schema/models/org";
import { GetUserRequest } from "src/gen/schema/brig/bapi";
import { User } from "src/gen/schema/models/user";
import { DeleteUserRequest } from "src/gen/schema/brig/bapi";
import { SetUsersRequest } from "src/gen/schema/brig/bapi";
import { DeleteApiKeyRequest } from "src/gen/schema/brig/bapikeys";
import { CreateBearerTokensRequest } from "src/gen/schema/brig/btokens";
import { AddOnboardDeviceTokensRequest } from "src/gen/schema/brig/btokens";
import { SignDeviceCertResponse } from "src/gen/schema/brig/bapi";

export const Brig = {
  echo: (
    request: EchoRequest,
    options?: RequestInit | undefined
  ): Promise<EchoResponse> => {
    return ReST.post(
      `/api/v1/hidden/echo/brig`,
      generatePayload(request, EchoRequest),
      options
    ).then((response) => response.json())
      .then(EchoResponse.fromJSON);
  },
  getOrg: (
    options?: RequestInit | undefined
  ): Promise<Organization> => {
    return ReST.get(
      `/ui/v1/organizations`,
      options
    ).then((response) => response.json())
      .then(Organization.fromJSON);
  },
  updateOrg: (
    request: UpdateOrgRequest,
    options?: RequestInit | undefined
  ): Promise<Organization> => {
    //Validate Body Annotation Field
    if (!request.organization) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.organization is invalid.")
      );
    }
    return ReST.put(
      `/ui/v1/organizations`,
      generatePayload(request, Organization, "organization"),
      options
    ).then((response) => response.json())
      .then(Organization.fromJSON);
  },
  deleteOrg: (
    options?: RequestInit | undefined
  ): Promise<Response> => {
    return ReST.delete(
      `/ui/v1/organizations`,
      options
    );
  },
  addTenant: (
    request: AddTenantRequest,
    options?: RequestInit | undefined
  ): Promise<AddTenantResponse> => {
    return ReST.post(
      `/api/v1/tenants`,
      generatePayload(request, AddTenantRequest),
      options
    ).then((response) => response.json())
      .then(AddTenantResponse.fromJSON);
  },
  updateTenant: (
    request: UpdateTenantRequest,
    options?: RequestInit | undefined
  ): Promise<TenantsResponse> => {
    //Validate Path Param: tenantId
    if (!request.tenantId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.tenantId is invalid.")
      );
    }
    //Validate Body Annotation Field
    if (!request.tenant) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.tenant is invalid.")
      );
    }
    return ReST.put(
      `/api/v1/tenants/${request.tenantId}`,
      generatePayload(request, Tenant, "tenant"),
      options
    ).then((response) => response.json())
      .then(TenantsResponse.fromJSON);
  },
  updateTenants: (
    request: UpdateTenantsRequest,
    options?: RequestInit | undefined
  ): Promise<TenantsResponse> => {
    return ReST.put(
      `/api/v1/tenants`,
      generatePayload(request, UpdateTenantsRequest),
      options
    ).then((response) => response.json())
      .then(TenantsResponse.fromJSON);
  },
  getTenants: (
    request: GetTenantsRequest,
    options?: RequestInit | undefined
  ): Promise<TenantsResponse> => {
    //Generate query params
    const queryParams = generateQueryParams(
      request
    );
    return ReST.get(
      `/api/v1/tenants${queryParams}`,
      options
    ).then((response) => response.json())
      .then(TenantsResponse.fromJSON);
  },
  getTenant: (
    request: GetTenantRequest,
    options?: RequestInit | undefined
  ): Promise<TenantsResponse> => {
    //Validate Path Param: tenantId
    if (!request.tenantId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.tenantId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["tenantId"]
    );
    return ReST.get(
      `/api/v1/tenants/${request.tenantId}${queryParams}`,
      options
    ).then((response) => response.json())
      .then(TenantsResponse.fromJSON);
  },
  deleteTenant: (
    request: DeleteTenantRequest,
    options?: RequestInit | undefined
  ): Promise<Response> => {
    //Validate Path Param: tenantId
    if (!request.tenantId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.tenantId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["tenantId"]
    );
    return ReST.delete(
      `/api/v1/tenants/${request.tenantId}${queryParams}`,
      options
    );
  },
  deleteTenants: (
    request: DeleteTenantsRequest,
    options?: RequestInit | undefined
  ): Promise<Response> => {
    //Generate query params
    const queryParams = generateQueryParams(
      request
    );
    return ReST.delete(
      `/api/v1/tenants${queryParams}`,
      options
    );
  },
  setUsers: (
    request: SetUsersRequest,
    options?: RequestInit | undefined
  ): Promise<UsersResponse> => {
    return ReST.post(
      `/api/v1/users`,
      generatePayload(request, SetUsersRequest),
      options
    ).then((response) => response.json())
      .then(UsersResponse.fromJSON);
  },
  getUsers: (
    request: GetUsersRequest,
    options?: RequestInit | undefined
  ): Promise<UsersResponse> => {
    //Generate query params
    const queryParams = generateQueryParams(
      request
    );
    return ReST.get(
      `/api/v1/users${queryParams}`,
      options
    ).then((response) => response.json())
      .then(UsersResponse.fromJSON);
  },
  getUser: (
    request: GetUserRequest,
    options?: RequestInit | undefined
  ): Promise<User> => {
    //Validate Path Param: userId
    if (!request.userId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.userId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["userId"]
    );
    return ReST.get(
      `/api/v1/users/${request.userId}${queryParams}`,
      options
    ).then((response) => response.json())
      .then(User.fromJSON);
  },
  updateUser: (
    request: UpdateUserRequest,
    options?: RequestInit | undefined
  ): Promise<User> => {
    //Validate Path Param: userId
    if (!request.userId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.userId is invalid.")
      );
    }
    //Validate Body Annotation Field
    if (!request.user) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.user is invalid.")
      );
    }
    return ReST.put(
      `/api/v1/users/${request.userId}`,
      generatePayload(request, UpdateUser, "user"),
      options
    ).then((response) => response.json())
      .then(User.fromJSON);
  },
  deleteUser: (
    request: DeleteUserRequest,
    options?: RequestInit | undefined
  ): Promise<Response> => {
    //Validate Path Param: userId
    if (!request.userId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.userId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["userId"]
    );
    return ReST.delete(
      `/api/v1/users/${request.userId}${queryParams}`,
      options
    );
  },
  deleteUsers: (
    request: DeleteUsersRequest,
    options?: RequestInit | undefined
  ): Promise<Response> => {
    //Generate query params
    const queryParams = generateQueryParams(
      request
    );
    return ReST.delete(
      `/api/v1/users${queryParams}`,
      options
    );
  },
  sendOrgInviteEmail: (
    request: SendOrgInviteEmailRequest,
    options?: RequestInit | undefined
  ): Promise<Response> => {
    return ReST.post(
      `/ui/v1/users/orgInvitations`,
      generatePayload(request, SendOrgInviteEmailRequest),
      options
    );
  },
  getSubscriptions: (
    options?: RequestInit | undefined
  ): Promise<SubscriptionsResponse> => {
    return ReST.get(
      `/api/v1/subscriptions`,
      options
    ).then((response) => response.json())
      .then(SubscriptionsResponse.fromJSON);
  },
  claimSubscriptions: (
    request: ClaimSubscriptionsRequest,
    options?: RequestInit | undefined
  ): Promise<SubscriptionsResponse> => {
    return ReST.put(
      `/api/v1/subscriptions`,
      generatePayload(request, ClaimSubscriptionsRequest),
      options
    ).then((response) => response.json())
      .then(SubscriptionsResponse.fromJSON);
  },
  unclaimSubscriptions: (
    request: ClaimSubscriptionsRequest,
    options?: RequestInit | undefined
  ): Promise<Response> => {
    //Generate query params
    const queryParams = generateQueryParams(
      request
    );
    return ReST.delete(
      `/api/v1/subscriptions${queryParams}`,
      options
    );
  },
  uploadApiKey: (
    request: UploadApiKeyRequest,
    options?: RequestInit | undefined
  ): Promise<ApiKey> => {
    return ReST.post(
      `/api/v1/apiKeys`,
      generatePayload(request, UploadApiKeyRequest),
      options
    ).then((response) => response.json())
      .then(ApiKey.fromJSON);
  },
  deleteApiKey: (
    request: DeleteApiKeyRequest,
    options?: RequestInit | undefined
  ): Promise<Response> => {
    //Validate Path Param: keyId
    if (!request.keyId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.keyId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["keyId"]
    );
    return ReST.delete(
      `/api/v1/apiKeys/${request.keyId}${queryParams}`,
      options
    );
  },
  getApiKeys: (
    request: GetApiKeysRequest,
    options?: RequestInit | undefined
  ): Promise<ApiKeysResponse> => {
    //Generate query params
    const queryParams = generateQueryParams(
      request
    );
    return ReST.get(
      `/api/v1/apiKeys${queryParams}`,
      options
    ).then((response) => response.json())
      .then(ApiKeysResponse.fromJSON);
  },
  createBearerToken: (
    request: CreateBearerTokenRequest,
    options?: RequestInit | undefined
  ): Promise<BearerToken> => {
    return ReST.post(
      `/api/v1/bearerToken`,
      generatePayload(request, CreateBearerTokenRequest),
      options
    ).then((response) => response.json())
      .then(BearerToken.fromJSON);
  },
  createBearerTokens: (
    request: CreateBearerTokensRequest,
    options?: RequestInit | undefined
  ): Promise<CreateBearerTokensResponse> => {
    return ReST.post(
      `/api/v1/bearerTokens`,
      generatePayload(request, CreateBearerTokensRequest),
      options
    ).then((response) => response.json())
      .then(CreateBearerTokensResponse.fromJSON);
  },
  deleteBearerToken: (
    request: DeleteBearerTokenRequest,
    options?: RequestInit | undefined
  ): Promise<Response> => {
    //Validate Path Param: tokenId
    if (!request.tokenId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.tokenId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["tokenId"]
    );
    return ReST.delete(
      `/api/v1/bearerTokens/${request.tokenId}${queryParams}`,
      options
    );
  },
  getBearerTokens: (
    request: GetBearerTokensRequest,
    options?: RequestInit | undefined
  ): Promise<BearerTokensResponse> => {
    //Generate query params
    const queryParams = generateQueryParams(
      request
    );
    return ReST.get(
      `/api/v1/bearerTokens${queryParams}`,
      options
    ).then((response) => response.json())
      .then(BearerTokensResponse.fromJSON);
  },
  getBearerToken: (
    request: GetBearerTokenRequest,
    options?: RequestInit | undefined
  ): Promise<BearerToken> => {
    //Validate Path Param: tokenId
    if (!request.tokenId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.tokenId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["tokenId"]
    );
    return ReST.get(
      `/api/v1/bearerTokens/${request.tokenId}${queryParams}`,
      options
    ).then((response) => response.json())
      .then(BearerToken.fromJSON);
  },
  addOnboardDeviceTokens: (
    request: AddOnboardDeviceTokensRequest,
    options?: RequestInit | undefined
  ): Promise<BearerTokensResponse> => {
    return ReST.post(
      `/ui/v1/onboardDeviceTokens`,
      generatePayload(request, AddOnboardDeviceTokensRequest),
      options
    ).then((response) => response.json())
      .then(BearerTokensResponse.fromJSON);
  },
  getOnboardDeviceTokens: (
    options?: RequestInit | undefined
  ): Promise<BearerTokensResponse> => {
    return ReST.get(
      `/ui/v1/onboardDeviceTokens`,
      options
    ).then((response) => response.json())
      .then(BearerTokensResponse.fromJSON);
  },
  updateUserPreferences: (
    request: UserPreferences,
    options?: RequestInit | undefined
  ): Promise<UserPreferences> => {
    return ReST.put(
      `/api/v1/userPreferences`,
      generatePayload(request, UserPreferences),
      options
    ).then((response) => response.json())
      .then(UserPreferences.fromJSON);
  },
  updateSupportAccess: (
    request: UpdateSupportAccessRequest,
    options?: RequestInit | undefined
  ): Promise<SupportAccessResponse> => {
    return ReST.put(
      `/api/v1/supportSettings`,
      generatePayload(request, UpdateSupportAccessRequest),
      options
    ).then((response) => response.json())
      .then(SupportAccessResponse.fromJSON);
  },
  getSupportAccess: (
    options?: RequestInit | undefined
  ): Promise<SupportAccessResponse> => {
    return ReST.get(
      `/api/v1/supportSettings`,
      options
    ).then((response) => response.json())
      .then(SupportAccessResponse.fromJSON);
  },
  signDeviceCert: (
    request: SignDeviceCertRequest,
    options?: RequestInit | undefined
  ): Promise<SignDeviceCertResponse> => {
    return ReST.post(
      `/api/v1/deviceCert`,
      generatePayload(request, SignDeviceCertRequest),
      options
    ).then((response) => response.json())
      .then(SignDeviceCertResponse.fromJSON);
  },
  signOnestepOnboardDeviceCSR: (
    request: SignDeviceCertRequest,
    options?: RequestInit | undefined
  ): Promise<SignDeviceCertResponse> => {
    return ReST.post(
      `/api/v1/onboardDeviceCsr`,
      generatePayload(request, SignDeviceCertRequest),
      options
    ).then((response) => response.json())
      .then(SignDeviceCertResponse.fromJSON);
  },
  signEula: (
    request: SignEulaRequest,
    options?: RequestInit | undefined
  ): Promise<SignEulaResponse> => {
    return ReST.post(
      `/ui/v1/eulas`,
      generatePayload(request, SignEulaRequest),
      options
    ).then((response) => response.json())
      .then(SignEulaResponse.fromJSON);
  },
};

